$(document).ready(function () {
  const anchorBtn = $('.anchor-links__item.active').find('.anchor-links__btn')
  if (anchorBtn.length !== 0) {
    const sectionId = $(anchorBtn[0]).attr('data-section')
    $(`.offers-by-city[id="${sectionId}"]`).addClass('show')
  }
  $('.anchor-links__item').on('click', function () {
    $('.anchor-links__item').removeClass('active')
    $(this).addClass('active')
    const anchorBtn = $(this).find('.anchor-links__btn')
    if (anchorBtn.length !== 0) {
      const sectionId = $(anchorBtn[0]).attr('data-section')
      $('.offers-by-city').removeClass('show')
      $(`.offers-by-city[id="${sectionId}"]`).addClass('show')
    }
  })
})